export const transformAccommodationValueToText = (value, literals)=>{
    if (!value || !literals) return '';
    const { adultAmountInfo ='' , adultsAmountInfo ='' , childAmountInfo ='' , childrenAmountInfo ='' , roomInfo ='' , roomsInfo ='' , passengerAmountInfo ='' , passengersAmountInfo =''  } = literals || {};
    let totalAdults = 0;
    let totalChildren = 0;
    let totalRooms = value.rooms.length;
    for (const room of value.rooms){
        totalAdults += room.adults;
        totalChildren += room.children;
    }
    const roomsTemplate = totalRooms === 1 ? roomInfo : roomsInfo;
    const adultsTemplate = totalAdults === 1 ? adultAmountInfo : adultsAmountInfo;
    const childrenTemplate = totalChildren === 1 ? childAmountInfo : childrenAmountInfo;
    const passengersTemplate = totalAdults + totalChildren === 1 ? passengerAmountInfo : passengersAmountInfo;
    const adultsString = adultsTemplate.replace('#number#', totalAdults.toString());
    const childrenString = childrenTemplate.replace('#number#', totalChildren.toString());
    const passengersString = passengersTemplate.replace('#number#', (totalAdults + totalChildren).toString());
    const roomsString = roomsTemplate.replace('#adults#', adultsString).replace('#children#', totalChildren > 0 ? childrenString : '').replace('#number#', totalRooms.toString()).replace('#passengers#', passengersString).replace(/ +(?= )/g, '');
    return roomsString;
};
export const accommodationToRooms = (rooms = [])=>rooms.map((person)=>({
            people: [
                {
                    value: person.adults
                },
                {
                    value: person.children,
                    selectedOptions: person.childrenAges ?? []
                }
            ]
        }));
export const convertNumberToSelectOption = (number, defaultValue)=>({
        label: String(number),
        value: String(number),
        selected: number === defaultValue
    });
export const initialOptions = (range, defaultValue = 0)=>Array.from({
        length: range + 1
    }, (_, i)=>convertNumberToSelectOption(i, defaultValue));
export const roomsToAccommodation = (rooms)=>rooms.map(({ people: [adults, children]  })=>({
            adults: adults.value,
            adultsAges: adults.selectedOptions?.map((x)=>Number(x)),
            children: children.value,
            childrenAges: children.selectedOptions?.map((x)=>Number(x))
        }));
const subtractToZero = (value, subtract)=>{
    if (value > 0 && subtract > 0) {
        return subtractToZero(value - 1, subtract - 1);
    }
    return {
        value,
        subtract: subtract
    };
};
export const createAccommodationRoom = (maxPeople, totalPeople, defaultAccommodationRoom)=>{
    const totalPeopleNewRoom = defaultAccommodationRoom.adults + defaultAccommodationRoom.children;
    const accommodation = {
        adults: 0,
        children: 0
    };
    let peopleSubtract = totalPeople + totalPeopleNewRoom - maxPeople;
    const accommodationRoom = Object.entries(defaultAccommodationRoom).reverse();
    accommodationRoom.forEach(([key, itemValue])=>{
        if (Number.isInteger(itemValue) && key in accommodation) {
            const { value , subtract  } = subtractToZero(itemValue, peopleSubtract);
            accommodation[key] = value;
            peopleSubtract = subtract;
        }
    });
    return accommodation;
};

//# sourceMappingURL=accommodation.js.map